<template>
  <section class="l-content-area">
    <div class="l-content l-content--mypage">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--mypage">
            <h1>マイページ</h1>
          </section>

          <section class="p-bloc p-bloc__mypage">
            <div class="p-mypage__user">
              <p class="user-status user-status--platinum"> {{ values.memberClassName }}</p>
              <h2 class="user-name">
                {{ values.lastName + ' ' + values.firstName }}<span>さま</span>
              </h2>
              <ul class="user-info">
                <li>顧客番号：{{ values.customerNumber }}</li>
                <li>所属店舗：{{ values.storeName }}</li>
              </ul>
              <div class="menu-btn">

                <div v-if="this.$authInfo.getBooking()" class="c-btn c-btn--mypage-menu">
                  <router-link v-if="allowedStores.includes(store.name) && process.env.VUE_APP_NODE_ENV === 'production'"
                   to="/mypage/reservation">ご来店予約はこちら</router-link>
<router-link v-else
 to="/mypage/reservation_studio">ご来店予約はこちら</router-link>
                </div>
                <div class="c-btn c-btn--mypage-menu">
                  <router-link to="/mypage/profile">ご登録情報の変更</router-link>
                </div>
              </div>
            </div>

            <div v-if="this.$authInfo.getBooking()">
              <div v-show="false" class="p-mypage__counter">
                <div class="mypage-counter">
                  <dl class="counter__title">
                    <dt>予約制限</dt>
                  </dl>
                  <template>
                    <v-simple-table>
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <td class="text-left"><span class="month-tag">今月</span></td>
                            <td>通常 :</td>
                            <td class="font-weight-bold">{{ counter.regular }}</td>
                            <td>指定 :</td>
                            <td class="font-weight-bold">{{ counter.specified }}</td>
                            <td>キャンセル待ち :</td>
                            <td class="font-weight-bold">{{ counter.waiting }}</td>
                          </tr>
                          <tr>
                            <td class="text-left"><span class="month-tag">来月</span></td>
                            <td>通常 :</td>
                            <td class="font-weight-bold">{{ counter.regular_next_month }}</td>
                            <td>指定 :</td>
                            <td class="font-weight-bold">{{ counter.specified_next_month }}</td>
                            <td>キャンセル待ち :</td>
                            <td class="font-weight-bold">{{ counter.waiting_next_month }}</td>
                          </tr>
                          <tr>
                            <td class="text-left"><span class="month-tag">再来月</span></td>
                            <td>通常 :</td>
                            <td class="font-weight-bold">{{ counter.regular_third_month }}</td>
                            <td>指定 :</td>
                            <td class="font-weight-bold">{{ counter.specified_third_month }}</td>
                            <td>キャンセル待ち :</td>
                            <td class="font-weight-bold">{{ counter.waiting_third_month }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </template>
                </div>
              </div>

              <div v-if="listReservationPending.length ||listReservationWaiting.length" class="p-mypage__schedule">
                <div class="mypage-schedule">
                  <dl v-if="listReservationPending.length" class="schedule__title">
                    <dt>来店予約スケジュール</dt>
                  </dl>
                  <div
                    v-for="(reservation, index) in listReservationPending"
                    :key="index"
                    class="schedule__bloc"
                    :value="index + 1"
                  >
                    <a href="#" @click="reservationDetail((value = 'isDetail'), reservation.id)">
                      <p v-if="reservation.start_date" class="date">
                        {{
                          formatReservationDateTime(reservation.start_date, reservation.start_date_display_minutes_diff)
                        }}
                      </p>
                      <p class="studio-name">{{ reservation.store.name }}</p>
                      <div v-if="reservation.services" class="servicesName">
                        <p v-for="service in reservation.services" :key="service.id">
                          {{ service.name }}
                        </p>
                      </div>
                    </a>
                  </div>
                  <dl v-if="listReservationWaiting.length" class="schedule__title">
                    <dt>キャンセル待ち</dt>
                    <dd>※予約確定ではございません</dd>
                  </dl>
                  <div
                    v-for="(reservation, index) in listReservationWaiting"
                    :key="reservation.id"
                    class="schedule__bloc"
                    :value="index + 1"
                  >
                    <a href="#" @click="reservationDetail((value = 'isWaiting'), reservation.id)">
                      <p v-if="reservation.start_date" class="date">
                        {{
                          formatReservationDateTime(reservation.start_date, reservation.start_date_display_minutes_diff)
                        }}
                      </p>
                      <p class="studio-name">{{ reservation.store.name }}</p>
                      <div v-if="reservation.services" class="servicesName">
                        <p v-for="service in reservation.services" :key="service.id">
                          {{ service.name }}
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div v-if="store.campaign" class="p-mypage__news">
                <h2>お知らせ</h2>
                <div class="">
                  <div class="d-flex news__bloc">
                    <p class="txt mb-1">
                      <ul class="tag">
                        <li class="c-tag"><span>{{ store.name }}</span></li>
                      </ul>
                    </p>
                    <p class="date mb-1">
                      {{
                        new Date(store.updated_at).getFullYear() +
                          '.' +
                          (new Date(store.updated_at).getMonth() + 1) +
                          '.' +
                          new Date(store.updated_at).getDate()
                      }}
                    </p>
                  </div>
                  <p class="text-left breakWord">{{ store.campaign }}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { getUser, getStore, getAllReservationByStatus } from '../../actions/requestMypage'
import { scrollToTop } from '../../helpers/index'
import { getDayOfWeekFromDateTime, getDateTimeFormatJapan, formatReservationDateTime } from '../../helpers/formatDate'
import { allowedStores } from '../../constant/listStores'

export default {
  name: 'MypageHome',
  components: {},
data() {
    return {
      accepted: 'accepted',
      waiting: 'waiting',
      pending: 'pending',
      provisional: 'provisional',
      getDayOfWeekFromDateTime,
      getDateTimeFormatJapan,
      formatReservationDateTime,
      listReservationPending: [],
      listReservationAccepted: [],
      listReservationWaiting: [],
      store: {},
      values: {
        memberClassName: '',
        firstName: '',
        lastName: '',
        userId: '',
        storeName: '',
        customerNumber: '',
      },
      state: 'jp-13',
      counter: {
        regular: '',
        regular_next_month: '',
        regular_third_month: '',
        specified: '',
        specified_next_month: '',
        specified_third_month: '',
        waiting: '',
        waiting_next_month: '',
        waiting_third_month: '',
      },
      allowedStores
    }
  },
  async created() {
    this.$reservation.resetReservation()
    scrollToTop()
    if (!sessionStorage.getItem('token')) {
      this.$router.push({
        name: 'home',
      })
    } else {
      this.$emit('startLoading')
      this.$authInfo.setToken(sessionStorage.getItem('token'))
      this.$authInfo.setBooking(parseInt(sessionStorage.getItem('booking')) === 1)
      await getAllReservationByStatus([this.pending ,this.waiting, this.provisional]).then(res => {
        const {
          data: { success },
        } = res
        if (success) {
          this.listReservationPending = res.data.data.filter(list => {
            return list.status === 'pending'
          }).sort((a, b) => {
            return new Date(a.start_date) - new Date(b.start_date)
          });

          this.listReservationWaiting = res.data.data.filter(list => {
            return list.status === 'waiting' || list.status === 'provisional'
          }).sort((a, b) => {
            return new Date(a.start_date) - new Date(b.start_date)
          });
        }
      })
      await getUser()
        .then(response => {
          const {
            data: { success },
          } = response
          if (success) {
            const {
              data: {
                data: { id, member_class_name, first_name, last_name, store_id, customer_no, regular_counter, specified_counter, waiting_counter, regular_counter_next_month, specified_counter_next_month, waiting_counter_next_month, regular_counter_third_month, specified_counter_third_month, waiting_counter_third_month },
              },
            } = response
            this.values.userId = id
            this.values.memberClassName = member_class_name || '一般会員'
            this.values.customerNumber = customer_no
            sessionStorage.setItem('userId', id)
            sessionStorage.setItem('customerNumber', customer_no)
            sessionStorage.setItem('memberClassName', member_class_name)
            sessionStorage.setItem('userInfo', JSON.stringify(response.data.data))
            this.values.firstName = first_name || ''
            this.values.lastName = last_name || ''
            this.counter.regular = regular_counter
            this.counter.regular_next_month = regular_counter_next_month
            this.counter.regular_third_month = regular_counter_third_month
            this.counter.specified = specified_counter
            this.counter.specified_next_month = specified_counter_next_month
            this.counter.specified_third_month = specified_counter_third_month
            this.counter.waiting = waiting_counter
            this.counter.waiting_next_month = waiting_counter_next_month
            this.counter.waiting_third_month = waiting_counter_third_month
            if (store_id) {
              getStore(store_id)
                .then(responseStore => {
                  if (responseStore.data.success) {
                    this.store = responseStore.data.data
                    this.values.storeName = responseStore.data.data.name
                    sessionStorage.setItem('studioInfo', JSON.stringify(responseStore.data.data))
                  }
                })
                .catch(err => {
                  return err
                })
            } else {
              this.values.storeName = ''
            }
          }
          this.$emit('endLoading')
        })
        .catch(err => {
          this.$emit('endLoading')
          return err
        })
    }
  },
  methods: {
    reservationDetail(value, id) {
      if (value) {
        localStorage.setItem('reservationDetail', value)
        localStorage.setItem('reservationDetailId', id)
      }
      this.$router.push({
        name: 'reservation-detail',params:{flag:id}
      })
    },
  },
}
</script>
<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}

.servicesName p {
  margin-bottom: 5px;
  font-size: 13px;
}

.news__bloc {
  justify-content: space-between;
}
.news__bloc .date {
  line-height: 27px;
  padding: 0;
  font-size: 15px;
}

.breakWord {
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
